import React from 'react';
import ReactSVG from 'react-svg';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import homeNoUpdates from '../img/home-no-updates.svg';
import newslettersArchive from '../img/newsletters-archive.svg';

import Render from '../common/Render';
import List from '../user/users/List';
import ProjectsEventsList from './projects/List';
import GoalsEventsList from './goals/List';
// import MessagesList from './messages/List';
import ListProjects from '../projects/List';
import { requestDataIfNeeded } from './duck';

class Screen extends React.Component {
  componentDidMount() {
    this.props.requestDataIfNeeded();
  }

  renderNewUsers = (newUsers) => {
    return <List users={newUsers} />;
  };

  renderNewProjects = (newProjects) => {
    const { t } = this.props;

    return (
      <ListProjects
        projects={newProjects}
        titlePrefix={t('home.newProjectsTitlePrefix')}
        titlePrefixColor="u-color-blue-violet"
        title={t('home.newProjectsTitle')}
        titleSuffix={t('home.newProjectsTitleSuffix')}
        className="u-margin-bottom"
      />
    );
  };

  renderNewSideProjects = (sideProjects) => {
    const { t } = this.props;

    return (
      <ListProjects
        projects={sideProjects}
        titlePrefix={t('home.newSideProjectsTitlePrefix')}
        titlePrefixColor="u-color-shakespeare"
        title={t('home.newSideProjectsTitle')}
        titleSuffix={t('home.newSideProjectsTitleSuffix')}
        className="u-margin-bottom"
      />
    );
  };

  renderAfterLoading = () => {
    const {
      newUsers,
      newProjects,
      newSideProjects,
      goalsGroupedByUsers,
      projectUpdates,
      t,
      noneEvents,
    } = this.props;

    if (noneEvents) {
      return (
        <div className="u-text-center">
          <h3>{t('home.noneEventsTitle')}</h3>
          <p className="u-weight-light">{t('home.noneEvents')}</p>
          <Link to="/my-profile" className="c-btn c-btn-outline">
            {t('general.goProfile')}
          </Link>
          <ReactSVG
            src={homeNoUpdates}
            className="u-margin-vertical"
            svgClassName="u-img-responsive u-margin-vertical-huge"
          />
          <div className="u-margin-bottom-huge">
            <p className="u-weight-light">{t('home.newsletterArchive')}</p>
            <Link to="/newsletters" className="c-btn c-btn-outline">
              {t('general.goArchive')}
            </Link>
          </div>
        </div>
      );
    }

    return (
      <div className="u-margin-bottom-huge">
        {!_.isEmpty(newUsers) && (
          <div className="u-margin-bottom">
            <h3>{t('home.newMembersTitle')}</h3>
            {this.renderNewUsers(newUsers)}
          </div>
        )}

        {!_.isEmpty(newProjects) && this.renderNewProjects(newProjects)}

        {!_.isEmpty(newSideProjects) && (
          <div className="u-margin-bottom">
            {this.renderNewSideProjects(newSideProjects)}
          </div>
        )}

        {!_.isEmpty(projectUpdates) && (
          <div className="u-margin-bottom">
            <ProjectsEventsList
              title={t('home.projectsEventsTitle')}
              events={projectUpdates}
            />
          </div>
        )}

        {!_.isEmpty(goalsGroupedByUsers) && (
          <GoalsEventsList
            titlePrefix={t('home.goalsTitlePrefix')}
            titleSuffix={t('home.goalsTitleSuffix')}
            title={t('home.goalsTitle')}
            goalsGroupedByUsers={goalsGroupedByUsers}
          />
        )}
        {/* TODO: Render all personal messages */}
        {/* <MessagesList /> */}
        {/* Go to Newsletters Archive */}
        <div className="u-text-center">
          <ReactSVG
            src={newslettersArchive}
            className="u-margin-top-large"
            svgClassName="u-img-responsive u-margin-vertical-huge"
          />
          <div className="u-margin-bottom-huge">
            <p className="u-weight-light">{t('home.newsletterArchive')}</p>
            <Link to="/newsletters" className="c-btn c-btn-outline">
              {t('general.goArchive')}
            </Link>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapDispatchToProps = { requestDataIfNeeded };

const mapStateToProps = ({ events }) => {
  const newUsers =
    events.data && events.data.filter(({ action }) => action === 'ADD_USER');

  const addProjectUpdates =
    events.data &&
    events.data
      .filter(({ action }) => action === 'ADD_PROJECT')
      .map(({ data }) => data.project);

  const newProjects =
    addProjectUpdates &&
    addProjectUpdates.filter((project) => project.type === 'DEFAULT');

  const newSideProjects =
    addProjectUpdates &&
    addProjectUpdates.filter((project) => project.type === 'SIDE');

  let goalsGroupedByUsers =
    events.data &&
    events.data.filter(({ action }) =>
      [
        'ADD_GOAL',
        'COMPLETE_GOAL',
        'UNCOMPLETE_GOAL',
        'REMOVE_GOAL',
        'ADD_GOAL_MEMO',
      ].includes(action)
    );

  const projectUpdates =
    events.data &&
    events.data.filter(
      ({ action }) =>
        action === 'UNJOIN_PROJECT' ||
        action === 'JOIN_PROJECT' ||
        action === 'ADD_PROJECT_MEMO'
    );

  goalsGroupedByUsers = _.groupBy(goalsGroupedByUsers, 'initiator._id');

  return {
    isLoading: events.isLoading,
    error: events.error,
    newUsers: newUsers && newUsers.map(({ initiator }) => initiator),
    newProjects,
    newSideProjects,
    goalsGroupedByUsers,
    projectUpdates,
    noneEvents: events.data && events.data.length === 0,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/events/Screen.js